import { useCallback, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import config from '../config';

export function useClientGuard() {
  const { getAccessTokenSilently } = useAuth0();
  const environment = process.env.REACT_APP_NODE_ENV || 'development';
  const apiUrl = config[environment].apiBaseUrl;

  const [isPromptOpen, setIsPromptOpen] = useState(false);
  const [suggestedClient, setSuggestedClient] = useState(null);

  const confirmSwitch = useCallback(() => {
    if (!suggestedClient) return;
    window.localStorage.setItem('currentClient', JSON.stringify(suggestedClient));
    window.location.reload();
  }, [suggestedClient]);

  const cancelPrompt = useCallback(() => {
    setIsPromptOpen(false);
    setSuggestedClient(null);
  }, []);

  const findOwningClient = useCallback(async (resourceType, id) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${await getAccessTokenSilently()}`,
      };

      let clients = null;
      try {
        clients = JSON.parse(window.localStorage.getItem('userClients'));
      } catch (_) {}

      if (!Array.isArray(clients) || clients.length === 0) {
        const resp = await fetch(`${apiUrl}/clients`, { headers, method: 'GET' });
        if (!resp.ok) return null;
        clients = await resp.json();
        window.localStorage.setItem('userClients', JSON.stringify(clients));
      }

      const endpointSuffix = resourceType === 'debt'
        ? `debt/${id}/summary`
        : `invoices/${id}/summary`;

      for (const client of clients) {
        try {
          const resp = await fetch(`${apiUrl}/clients/${client.id}/${endpointSuffix}`, {
            headers,
            method: 'GET',
          });
          if (resp.ok) {
            setSuggestedClient(client);
            setIsPromptOpen(true);
            return client;
          }
        } catch (_) {
        }
      }

      return null;
    } catch (_) {
      return null;
    }
  }, [apiUrl, getAccessTokenSilently]);

  const checkAndPromptByVizionId = useCallback(async (resourceVizionClientId) => {
    if (resourceVizionClientId == null) return false;
    const toNum = (v) => (v == null || v === '' || Number.isNaN(Number(v)) ? null : Number(v));
    let currentClient = null;
    try {
      currentClient = JSON.parse(window.localStorage.getItem('currentClient'));
    } catch (_) {}
    const currentVizionId = toNum(currentClient?.vizionClientId);
    const resourceIdNum = toNum(resourceVizionClientId);
    if (currentVizionId != null && resourceIdNum != null && currentVizionId === resourceIdNum) return false;

    let clients = null;
    try {
      clients = JSON.parse(window.localStorage.getItem('userClients'));
    } catch (_) {}

    if (!Array.isArray(clients) || clients.length === 0) {
      try {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await getAccessTokenSilently()}`,
        };
        const resp = await fetch(`${apiUrl}/clients`, { headers, method: 'GET' });
        if (resp.ok) {
          clients = await resp.json();
          window.localStorage.setItem('userClients', JSON.stringify(clients));
        }
      } catch (_) {}
    }

    const match = Array.isArray(clients)
      ? clients.find(c => toNum(c?.vizionClientId) === resourceIdNum)
      : null;
    if (match) {
      setSuggestedClient(match);
      setIsPromptOpen(true);
      return true;
    }
    return false;
  }, [apiUrl, getAccessTokenSilently]);

  return {
    isPromptOpen,
    suggestedClient,
    confirmSwitch,
    cancelPrompt,
    findOwningClient,
    checkAndPromptByVizionId,
  };
}


